import { useEffect, useState } from "react";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { Input } from "../../../../Input/Input";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";
import { encryptPW } from "../../../../../ApiTS/ApiCommonTS";
import RadioBtn from "../../../../Button/RadioBtn";

interface Props extends DefaultModalCommonProps {
  partyId: number;
  uid: number;
  shareid: string;
  extrainfo: string;
  linkidmail?: string;
}

export default function ShareIDChangeModal({
  closeEvent,
  confirmEvent,
  partyId,
  uid,
  shareid,
  extrainfo,
  linkidmail,
}: Props) {
  const [reset, setReset] = useState(false);

  const parsedShareId = () => {
    if (shareid) {
      return JSON.parse(shareid);
    }
  };

  const [new_shareid, setNew_shareid] = useState(
    parsedShareId() || { shareid: "", profileName: "" }
  );
  const [new_extraInfo, setNew_extraInfo] = useState(extrainfo);

  const { response, loading, error } = useApi({
    method: "post",
    url: reset ? `party/${partyId}/shareid/user/` : "",
    data: {
      shareid: JSON.stringify(new_shareid),
      uid: uid,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("계정이 변경 되었습니다.");
      if (confirmEvent) confirmEvent();
      closeEvent();
    }
  }, [response]);

  // useEffect(() => {
  //   if (error) {
  //     toast.error(error?.data ?? "비밀번호 재설정에 실패했습니다.");
  //     setReset(false);
  //   }
  // }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={closeEvent}
      confirmEvent={() => {
        setReset(true);
      }}
      isLargeModal
      modalTitle="계정 변경하기"
      confirmDisabled={false}
    >
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>현재 계정</ModalLabel>

        <ModalRowContentContainer style={{ flex: 1 }}>
          <ModalLabel>{parsedShareId()?.shareid}</ModalLabel>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>변경 계정</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <Input
            placeholder="변경할 계정을 입력해 주세요"
            value={new_shareid.shareid}
            onChange={(e) =>
              setNew_shareid({ ...new_shareid, shareid: e.target.value })
            }
          />
        </ModalRowContentContainer>
      </ModalRow>

      <div
        style={{ height: 2, width: "100%", backgroundColor: "#8b8b8b" }}
      ></div>

      {/* dd */}
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>현재 프로필 네임</ModalLabel>

        <ModalRowContentContainer style={{ flex: 1 }}>
          <ModalLabel>{parsedShareId()?.profileName}</ModalLabel>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>변경 프로필 네임</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <Input
            placeholder="변경할 프로필 네임을 입력해 주세요"
            value={new_shareid.profileName}
            onChange={(e) =>
              setNew_shareid({ ...new_shareid, profileName: e.target.value })
            }
          />
        </ModalRowContentContainer>
      </ModalRow>

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
